/**
 * Sprungleiste (Telefon), aufklappbare Sektion, Rechenzeile, Verlauf.
 * Aus pages/ProjektDetailPage.tsx herausgelöst (Plan Projekt-Tracking, Etappe 2) —
 * verschoben, nicht umgeschrieben.
 */
import { Sektion, Sprungleiste } from "@vimaana/ui";
import "@vimaana/ui/sektion";
import { ProjektVerlauf, useProjektVerlaufKopf } from "./ProjektPost";
import { formatEur } from "../../lib/planer";

// Die aufklappbare Sektion ist seit 09.10.2026 gemeinsam mit der Pflege
// (@vimaana/ui); die Importe aus dieser Datei bleiben gültig.
export { Sektion };

/* ══ Sprungleiste (Telefon) ══════════════════════════════════════════════ */

export const SPRUENGE = [
  { anker: "stand", label: "Stand" },
  { anker: "kosten", label: "Kosten" },
  { anker: "plan", label: "Plan" },
  { anker: "termine", label: "Termine" },
  { anker: "material", label: "Material" },
  { anker: "dokumente", label: "Dokumente" },
  { anker: "verlauf", label: "Verlauf" },
];

export function istTelefon(): boolean {
  try {
    return window.matchMedia("(max-width: 760px)").matches;
  } catch {
    return false;
  }
}

/**
 * Am Telefon liegen neun Sektionen untereinander, die unteren erreichte man nur
 * über langes Scrollen (Benjamin 28.09.2026: „alles übersichtlich erreichen").
 * Die Leiste klebt oben; ein Tipp klappt die Sektion auf und springt hin.
 * Auf breiten Schirmen ist sie ausgeblendet — dort steht alles im Blick.
 */
export function ProjektSprung() {
  return <Sprungleiste ziele={SPRUENGE} />;
}

/* ══ Aufklappbare Sektion ════════════════════════════════════════════════ */

/** Der eine Verlauf des Projekts: Post, Belegereignisse, Termine, Notizen, Fotos — filterbar. */
export function VerlaufSektion({ projektId }: { projektId: string }) {
  const kopf = useProjektVerlaufKopf(projektId);
  return (
    <Sektion titel="Verlauf & Post" anker="verlauf" kopfRechts={kopf || undefined}>
      <ProjektVerlauf projektId={projektId} />
    </Sektion>
  );
}

export function RechnungZeile({ label, wert, summe }: { label: string; wert: number; summe?: boolean }) {
  return (
    <div className={"vg-rechnung-zeile" + (summe ? " is-summe" : "")}>
      <span>{label}</span>
      <span className="vg-rechnung-betrag">{formatEur(wert, { round: true })}</span>
    </div>
  );
}
